import React, {useContext, useEffect, useRef, useState} from 'react';
import {AuthContext} from "../../../context/AuthContext";
import {useHttp} from "../../../hooks/http.hook";
import {observer} from "mobx-react";
import OrgPatientListStore from "./store/OrgPatientListStore";
import {useReactToPrint} from "react-to-print";
import ReactLoading from "react-loading";
import Modal from "../../Modal";


const PrintModal = observer(() => {
    const {request} = useHttp()
    const {token} = useContext(AuthContext)
    const [image, setImage] = useState()
    const [status, setStatus] = useState()
    const componentRef = useRef();
    const handlePrint = useReactToPrint({content: () => componentRef.current,});
    const baseURL = process.env.REACT_APP_BASE_URL

    const printModal = OrgPatientListStore.printModal

    const getResultImage = async () => {
        const url = `${baseURL}/api/v2/general/patients/${printModal.patientId}/results/${printModal.resultId}`
        const {data, status} = await request(url, "GET", null, {Authorization: `Bearer ${token.token}`})
        if (data.message === 'результаты не найдены') {
            setStatus(400)
        } else setStatus(status)

        if (data.data[0]?.image && status === 200) {
            setImage(data.data[0].image)
            handlePrint()
        }

    }

    useEffect(() => {
        getResultImage()

    }, [])

    const closeModal = () => {
        OrgPatientListStore.closeImageId()
        setImage('')
    }
    return (
        <Modal>
            <div className="close-icon" onClick={closeModal}><i className="fas fa-times"/></div>
            {status >= 400 ?
                <div style={{color: 'white', fontSize: '20px'}}>Что-то пошло не так. Попробуйте позже </div> : ''}
            {image !== '' && status === 200 || status === 400 ?
                <img className={'img'} ref={componentRef} src={image} alt=""/> :
                <ReactLoading type={'spin'} color='#fff' height={100} width={100}/>
            }
        </Modal>
    );
})

export default PrintModal;